import { Component, Inject, ViewChild, forwardRef } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import * as moment from "moment";
import { WorkOrder, WorkOrderStatus } from "../../model";


@Component({
    selector: 'work-order-edit-dialog',
    template: require('./work-order-edit-dialog.component.html')
})
export class WorkOrderEditDialogComponent {

    @ViewChild('form') form: NgForm;

    workOrder: WorkOrder;
    statusOnly: boolean;
    statuses: string[] = Object.values(WorkOrderStatus);
    startMoment: moment.Moment;
    endMoment: moment.Moment;

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) public dialogRef: MatDialogRef<WorkOrderEditDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data
    ) {
        this.statusOnly = data.statusOnly;
        this.workOrder = data.workOrder;
        if (this.workOrder.startTimestamp) {
            this.startMoment = moment(this.workOrder.startTimestamp);
        }
        if (this.workOrder.endTimestamp) {
            this.endMoment = moment(this.workOrder.endTimestamp);
        }
    }

    save(): void {
        const formValue = this.form.form.getRawValue();
        let body;
        if (this.statusOnly) {
            body = Object.assign({}, this.workOrder, { status: formValue.status });
        } else {
            body = formValue;
            if (body.startMoment) {
                body.startTimestamp = body.startMoment.valueOf();
                delete body.startMoment
            }
            if (body.endMoment) {
                body.endTimestamp = body.endMoment.valueOf();
                delete body.endMoment
            }
        }
        this.dialogRef.close(body);
    }

}